import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { GET_DLM_WISE_BANK_DEPOSIT_REPORT } from "../../../Types";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import * as XLSX from "xlsx";
import fileSaver from "file-saver";

export const getDataListing = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/BankDeposit/DLMWiseBankDepositReport`, postedData)
    .then(({ data }) => {
      dispatch({
        type: GET_DLM_WISE_BANK_DEPOSIT_REPORT,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/BankDeposit/DLMWiseBankDepositReport`, requestData)
    .then(({ data }) => {
      const outputFilename = `Deliveryman_Wise_Bank_Deposit_Report${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const formatDepositDate = (value) => {
        if (!value) return "";

        const [year, month, day] = value.split("T")[0].split("-");
        return year && month && day ? `${day}/${month}/${year}` : value;
      };

      const exportToExcel = (reportData, fileName) => {
        const exportData = (reportData || []).map((row) => ({
          Distributor: row.distributor,
          "Distribution Center": row.distributionCenter,
          "Deliveryman Name": row.deliverymanName,
          Date: formatDepositDate(row.depositDate),
          "Total Amount Collected": row.totalAmountCollected,
          "Total Amount Deposit": row.totalAmountDeposit,
          "Total Amount In Hand": row.totalAmountInHand,
        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };
      exportToExcel(data?.response?.data, outputFilename);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
